import React from 'react';
import CRUDPage from './CRUDPage';
import submenuLegos from './menus/submenu-legos';
import MongoDocEditor from '../components/lego/MongoDocEditor';
import BadgeId from '../components/common/BadgeId';
import NiceDate from '../components/common/NiceDate';
import { StableUrlsFiltersBar } from '../components/common/StableUrlsFiltersBar';
import CountryFlag from '../components/common/CountryFlag';
import { IconButton } from '../components/common/IconButton';
import BadgeColorHash from '../components/common/BadgeColorHash';
import LegoEditButton from '../components/lego/LegoEditButton';
import TrimSpec from '../components/lego/trims/TrimSpec';
import { UserAvatar } from '../components/common/UserAvatar';
import { LocaleFlag } from '../components/lego/LocaleFlag';


export default class StableUrlsManager extends CRUDPage {
  constructor(props) {
    super(props, 'services/stable-urls/collection');
    this.submenu = submenuLegos;
    // this.state.facetFilters = { type: 'fusebox' };

    this.canDelete = false;
    this.canCreate = false;
    this.canEdit = false;
  }

  getFacetFiltersComponent() {
    return <StableUrlsFiltersBar onChange={this.onFiltersChange.bind(this)} filter={this.state.facetFilters} />
  }

  async fetchObjects() {
    await super.fetchObjects({ $sort: { updatedAt: -1 }, $limit: 200 });
  }

  getColumnsDefinition(objects) {
    return [
      { content: 'Updated', className: '', sorter: (su) => su.updatedAt },
      { content: 'Locale', className: 'text-center', sorter: (su) => su.locale },
      { content: 'Type', className: 'text-center', sorter: (su) => su.type },
      { content: 'Country', className: 'text-center', sorter: (su) => su.country },
      { content: 'Key', className: '', sorter: (su) => su.key },
      { content: 'ID', className: '', sorter: (su) => su._id },
      { content: 'URL', className: '', sorter: (su) => su.url },
      { content: 'Active', className: 'text-center', sorter: (su) => su.active },
      { content: 'Total uses', className: 'text-center', sorter: (su) => su.useCount || 0 },
      { content: 'Last used', className: '', sorter: (su) => su.lastUsedAt || 0 },
      { content: 'Source', className: 'text-center' },
      { content: '', className: '' },
    ];
  }

  showMetadata(stableUrl) {
    this.openModal(
      <pre className={'monospace small break-word-all'}>{JSON.stringify(stableUrl.metadata, null, 2)}</pre>,
      { title: `Metadata ${stableUrl._id} (${stableUrl.country}:${stableUrl.key}:${stableUrl.url})` }
    );
  }

  getRowClasses(obj, i, rows) {
    const { active, redirect } = obj;
    let year = obj.url.slice(0,4);
    let prevRowYear = rows[i-1]?.url?.slice(0,4);
    return (active ? '' : (redirect ? 'bg-light-secondary' : 'bg-light-danger')) + (prevRowYear !== year ? ' row-border-top-2' : '');
  }

  getObjectColumns(stableUrl, definition) {
    const {
      _id, locale, type, country, key, id, url, redirect, active, updatedAt, metadata, updatedBy, createdBy,
      useCount, lastUsedAt,
    } = stableUrl;


    let _modelId = metadata?.context?._modelId;
    let _fromFamilyModelId = metadata?.context?._fromFamilyModelId;

    return [
      <td key={'updatedAt'}>
        {updatedAt ? <NiceDate t={updatedAt} /> : '-'}
      </td>,

      <td key={'locale'} className={'text-center'}>
        <LocaleFlag locale={locale} />
      </td>,

      <td key={'type'} className={'text-center'}>
        <span className={'badge badge-info'}>{type}</span>
      </td>,

      <td key={'country'} className={'text-center'}>
        <CountryFlag countryCode={country} />
        <span className={'ml-1 small text-muted'}>{country}</span>
      </td>,

      <td key={'key'} className={'monospace'}>
        <TrimSpec spec="modelId" value={key} />
      </td>,

      <td key={'id'} className={'monospace'}>
        <LegoEditButton legoId={id}>
          <BadgeColorHash id={id} />
        </LegoEditButton>
      </td>,

      <td key={'url'} className='monospace'>
        <span className={`text-${active ? 'info' : 'dark translucent'}`} title={url}>{url}</span>
        {redirect ? (
          <span className={'text-primary ml-2'}>
            ⟶ {redirect.key && <><TrimSpec spec="modelId" value={redirect.key} /> /</>}
            {redirect.url}
          </span>
        ) : null}
      </td>,

      <td key={'active'} className={'text-center'}>
        {active ? (
          <span className={'badge badge-success'}>Active</span>
        ) : (
          <span className={'badge badge-secondary'}>Inactive</span>
        )}
      </td>,

      <td key={'totalUses'} className="text-center">
        {useCount != null ? useCount : '-'}
      </td>,

      <td key={'lastUsedAt'}>
        {lastUsedAt ? <NiceDate t={lastUsedAt} /> : '-'}
      </td>,

      <td key={'source'} className='small'>
        { _modelId && _modelId !== metadata?.context?.modelId ? <>Via @Gen <TrimSpec spec="modelId" value={_modelId} /></> : null }
        { _fromFamilyModelId ? <>Via Family <TrimSpec spec="modelId" value={_fromFamilyModelId} /></> : null }
      </td>,

      <td key={'actions'}>
        {metadata ? (
          <IconButton icon="visibility" small onClick={() => this.showMetadata(stableUrl)}>
            Metadata
          </IconButton>
        ) : null}
      </td>,
    ];
  }

  getObjectEditorComponent(obj, defaultOnSaveCbk, defaultOnCancelCbk) {
    return <MongoDocEditor obj={obj} onSave={defaultOnSaveCbk} onCancel={defaultOnCancelCbk} />
  }
}

// DEVELOPMENT ONLY
